import { useState, useEffect } from 'react';

/**
 * useViewport
 * Detecta el tamaño de la ventana del navegador y devuelve
 * breakpoints estándar. Reemplaza useWindowDimensions de React Native.
 */
export function useViewport() {
  const [width, setWidth] = useState<number>(globalThis.innerWidth);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      setWidth(globalThis.innerWidth);
    });

    observer.observe(document.documentElement);

    return () => observer.disconnect();
  }, []);

  // Breakpoints basados en métricas estándar
  const isMobile  = width < 768;
  const isTablet  = width >= 768 && width < 1024;
  const isDesktop = width >= 1024;

  return {
    isMobile,
    isTablet,
    isDesktop,
    // Coarse es para pantallas puramente táctiles sin puntero de precisión
    isCoarsePointer: isMobile || isTablet,
    viewportWidth: width,
  };
}
